module.exports = __webpack_public_path__ + "img/26.bc178338.png";